<div class="billing-header">
  <h1>Billing</h1>
  <section
      *ngIf="nativeTeamContextReady && isNativeTeamContextActive"
      class="native-team-context"
      aria-label="Billing Team context"
  >
    <div class="native-team-summary">
      <span class="native-team-label">Team</span>
      <strong>{{selectedNativeTeam?.name || 'No Team selected'}}</strong>
    </div>
    <mat-form-field *ngIf="nativeTeams.length > 1" appearance="outline">
      <mat-label>Team</mat-label>
      <mat-select [value]="selectedTeamId" (selectionChange)="onNativeTeamChange($event.value)">
        <mat-option *ngFor="let team of nativeTeams" [value]="team.id">{{team.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <span *ngIf="nativeTeams.length === 0" class="native-team-empty">
      No Teams are available for this company.
    </span>
  </section>
</div>
<span class="achinfo" *ngIf="badgeCount > 0"
    >You have {{ badgeCount }} pending ACH transfer{{ badgeCount === 1 ? '' : 's' }}</span
>
<span class="balance" *ngIf="currentWellspaceId && !balanceLoading && !balanceLoadError">
    Account balance {{ -balance | currency }}
</span>
<span class="balance-state" *ngIf="currentWellspaceId && balanceLoading">Loading Team balance…</span>
<span class="balance-state balance-error" *ngIf="balanceLoadError">{{balanceLoadError}}</span>
<nav mat-tab-nav-bar [tabPanel]="tabs">
    <a
        mat-tab-link
        *ngFor="let link of links"
        [routerLink]="link.link"
        (click)="activeLink = link"
        [active]="activeLink == link"
        >{{ link.title }}</a
    >
</nav>
<app-stripepaymentmethods *ngIf="activeLink?.title === 'Payment Methods'"></app-stripepaymentmethods>
<app-stripe-available-payment-methods
    *ngIf="activeLink?.title === 'Add Available Payment Method'"
></app-stripe-available-payment-methods>
<app-stripecreditcard *ngIf="activeLink?.title === 'Add Payment Method'"></app-stripecreditcard>
<app-stripe-chargehistory *ngIf="activeLink?.title === 'Charge History'"></app-stripe-chargehistory>
<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
